
export const SET =  (state, [variable, value]) =>{
    state[variable] = value
}

export const LOGIN_DATA =  (state,data) =>{
    state.loginData = data;
}

export const LINK_CREDENTIAL =  (state,data) =>{
    state.linkCredential = data;
}